import {HTTP} from "../../_helpers/http";
import {config} from "@shared/_services/config";

export default class RegistrationApi {

    static getOpen() {
        return HTTP.get(config.userApi.registration)
            .then(response => response.data)
    }

    static delete(registrationId) {
        return HTTP.delete(`${config.userApi.registration}/${registrationId}`)
            .then(response => response.data);
    }
}